import { z } from "zod";
import { artifactKindSchema, artifactOperationSchema, artifactProviderSchema, artifactVersionStatusSchema, } from "./artifacts.js";
import { externalClientAppSchema } from "./client-attribution.js";
/*
 * An artifact as a feed row shows it: the channel feed's artifact and session rows, and the
 * workspace Feed's finished runs. Its own module so feed.ts and channel-feed.ts can both use it.
 */
export const channelFeedArtifactSchema = z.object({
    id: z.string().trim().min(1),
    taskId: z.string().trim().min(1),
    sessionId: z.string().trim().min(1).optional(),
    provider: artifactProviderSchema,
    kind: artifactKindSchema,
    title: z.string().trim().min(1),
    href: z.string().trim().min(1).optional(),
    versionId: z.string().trim().min(1),
    version: z.number().int().positive(),
    operation: artifactOperationSchema.optional(),
    addedToChannel: z.boolean().optional(),
    status: artifactVersionStatusSchema,
    sourceRunId: z.string().trim().min(1),
    sourceSessionId: z.string().trim().min(1).optional(),
    sourceToolName: z.string().trim().min(1).optional(),
    authorId: z.string().trim().min(1).optional(),
    interfaceType: z.enum(["api", "cli", "mcp"]).optional(),
    clientApp: externalClientAppSchema.optional(),
});
export const channelFeedRelatedArtifactsSchema = z.object({
    items: z.array(channelFeedArtifactSchema).max(3),
    totalCount: z.number().int().nonnegative(),
}).strict();
